var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'd-flex justify-start justify-md-center': _vm.center }},[_c('img',{attrs:{"src":require("@/assets/img/_src/wave-mini.svg"),"alt":"Маленькая волнистая линия"}})])}
var staticRenderFns = []

export { render, staticRenderFns }